import { AlertTriangle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { CatalogSource, PluginCatalogStatus } from "@/types";

// #287: EINE Darstellung für den Katalog-Zustand — Liste, Marketplace-Detail und die
// Per-Agent-Sicht zeigen dasselbe, sonst driften drei Erklärungen auseinander.

export function PluginStatusBadge({ status }: { status: PluginCatalogStatus }) {
  if (status === "available") return <Badge variant="available">verfügbar</Badge>;
  if (status === "orphaned") {
    return (
      <Badge variant="disabled" title="Steht nicht mehr in der marketplace.json — wird nicht mehr ausgeliefert. Die Zuweisung bleibt bestehen und lebt wieder auf, sobald der Eintrag zurückkommt.">
        verwaist
      </Badge>
    );
  }
  return (
    <Badge variant="busy" title="Die Quelle war gerade nicht lesbar — ob es das Plugin noch gibt, wissen wir nicht. Es wird nichts weggenommen.">
      Quelle nicht lesbar
    </Badge>
  );
}

// #287 (UC-3): Nicht lesbare Quellen werden AUSGEWIESEN — eine leere Liste wäre die Lüge
// „da ist nichts". Rendert nichts, wenn alle Quellen gelesen werden konnten.
export function CatalogSourceAlert({ sources }: { sources: CatalogSource[] | undefined }) {
  const broken = (sources ?? []).filter((s) => !s.ok);
  if (broken.length === 0) return null;
  return (
    <div
      className="mb-3 flex items-start gap-2 rounded-md border border-warn-border bg-warn-bg px-3 py-2 text-[12.5px] text-warn"
      data-testid="catalog-source-error"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <div>
        <div className="font-semibold">
          {broken.length === 1 ? "Eine Quelle" : `${broken.length} Quellen`} konnte(n) nicht gelesen werden
        </div>
        <ul className="mt-1 space-y-0.5">
          {broken.map((s) => (
            <li key={s.marketplaceId}>
              <span className="font-medium">{s.marketplaceName || s.marketplaceId}</span>
              {s.error ? <span className="mono text-[11.5px]"> — {s.error}</span> : null}
            </li>
          ))}
        </ul>
        <div className="mt-1 opacity-80">
          Die Liste ist unvollständig. Zuweisungen bleiben unverändert bestehen — es wird nichts entfernt,
          solange die Quelle nicht gelesen werden konnte.
        </div>
      </div>
    </div>
  );
}
